module.exports = __webpack_public_path__ + "img/animationassist-jp.cf99086.jpg";